export default __webpack_public_path__ + "img/img_sarun-8c9d3ed6afaa16ebf34b84f06f8d536d.png";